module.exports = __webpack_public_path__ + "ed271ed47e1d4b35a8328ab9f5f6c71b.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/sarah-drasner.jpg
// module id = 677
// module chunks = 0